//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { onlyNumbers } from "../../utils/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "NumericInput",
  props: {
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Boolean, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    className: {
      type: [String, Object],
      default: null
    }
  },
  methods: {
    onlyNumbers(event) {
      return onlyNumbers(event);
    },
    handleChange(event) {
      this.$emit("change", event);
    },
    handleFocusOut(event) {
      this.$emit("focusout", event);
    }
  }
});